<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-VIEW' : 'EDIT-VIEW') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <!--Name-->
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="name.hasError('required') && name.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                        {{'VIEW-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--View Type-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'VIEW-TYPE' | translate}} *
                    </span>
                    <div>
                        <span>
                            <input type="radio" value="METRIC" name="viewType" formControlName="viewType"
                                id="radioMetric" kendoRadioButton />
                            <label class="k-radio-label" for="radioMetric" [ngClass]="{'k-disabled': disableControls}">{{'REPORT-TYPE-METRIC' |
                                translate}}
                            </label>
                        </span>
                        <span>
                            <input type="radio" value="REPORT" name="viewType" formControlName="viewType"
                                id="radioReport" kendoRadioButton />
                            <label class="k-radio-label" for="radioReport" [ngClass]="{'k-disabled': disableControls}">{{'REPORT-TYPE-REPORT' |
                                translate}}
                            </label>
                        </span>
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="viewType.hasError('required') && viewType.touched">
                        {{'REQUIRED-VIEW-TYPE' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--View Name-->
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'VIEW-NAME' | translate}} *
                    </span>
                    <kendo-combobox id="viewName" formControlName="viewName" class="w-100" [data]="viewNames"
                        [valueField]="'value'" [textField]="'text'" [valuePrimitive]="true">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="viewName.hasError('required') && viewName.touched">
                        {{'REQUIRED-VIEW-NAME' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--Authorized Roles-->
        <div class="row">
            <div class="col-12">
                <label class="k-form-field mt-0">
                    <span class="k-text-uppercase dark">
                        {{'AUTHORIZED-ROLES' | translate}} *
                    </span>
                    <kendo-multiselect #activeUserRoles [data]="activeRoles" [valuePrimitive]="true"
                        formControlName="authorizedRoles" [textField]="'text'" [valueField]="'value'">
                    </kendo-multiselect>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="authorizedRoles.hasError('required') && authorizedRoles.touched">
                        {{'REQUIRED-AUTHORIZED-ROLES' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>